export function setDefaultValue(
    setInputState: Function,
    name: string,
    defaultValue: string
) {
    setInputState((state: any) => ({ ...state, [name]: defaultValue }))
}
